import { Tag } from '../tag';

export const StoreTag = (props: { status: string }) => {
    switch (props.status) {
        case 'open':
            return <Tag variant="blue">Open</Tag>;
        case 'open-24':
            return <Tag variant="blue">Open 24</Tag>;
        case 'no-car-wash':
            return <Tag variant="blue">No Car Wash</Tag>;
        case 'closed':
            return <Tag variant="error">Closed</Tag>;
        case 'temporarily-closed':
            return <Tag variant="volcano">Closed Temporarily</Tag>;
        case 'coming-soon':
            return <Tag variant="blue">Coming Soon</Tag>;
        default:
            return <Tag variant="purple">{props.status}</Tag>;
    }
};
